var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"response"}},[(!_vm.showform)?_c('div',{staticClass:"mt-5 mb-0",domProps:{"innerHTML":_vm._s(_vm.$t('respuestaform'))}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }